import React, { useEffect } from 'react';
import axios from 'axios';
import endpoints from '../../define/endpoints';
import { Loader } from '../common';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';

const ModalDownloadFile = ({ order, isOpen, setIsOpen, token }) => {
  const downloadVoucher = async () => {
    if (!order || !order.id || !token) return;

    const orderId = order.id;
    const orderType = order.type;

    // console.log('order', order);

    try {
      const response = await axios.get(
        `${endpoints.core}/orders/${orderId}/file`,
        {
          responseType: 'blob',
          params: { locale: window.freedomeConfig.locale },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log('response', response);

      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/pdf',
      });
      // temporary download link
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      const extension = response.headers['content-type']
        ? response.headers['content-type'].split('/')[1]
        : 'pdf';
      link.download = `${orderType}_${orderId}.${extension}`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      // console.error(error);
    } finally {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (!isOpen || !order) return;

    downloadVoucher();
  }, [isOpen, order]);

  return isOpen
    ? createPortal(
      <CSSTransition
        classNames="full-page-loader-container"
        in={isOpen}
        mountOnEnter={true}
        unmountOnExit={true}
        appear={true}
        timeout={200}
      >
        <div className="full-page-loader-container">
          <Loader className={'full-page-loader-container__loader'} />
        </div>
      </CSSTransition>,
      document.body
    )
    : null;
};

ModalDownloadFile.propTypes = {
  order: PropTypes.object,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export { ModalDownloadFile };
